import React, { useEffect, useState } from "react";
import FullLayout from "@/layouts/FullLayout";
import HeaderNav from "./HeaderNav";
import { apiHost, apiKey } from "@/constants";
import { useScannerContext } from "../scanners/ScannerContext";
import { appLog } from "../scanners/helpers";
import { sortBy } from "@/helpers/object.helpers";
import { Scan } from "./Scan";
import { List } from "./List";
import { ApiResponse, RowData } from "./types";

export const PickList: React.FC = () => {
  const { clearScannedData } = useScannerContext();
  const [rowData, setRowData] = useState<Array<RowData> | null>(null);
  const [selectedCard, setSelectedCard] = useState<RowData | null>(null);

  const fetchApiData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("skip", "0");
      params.append("limit", "100");
      const response = await fetch(`${apiHost}/order-quality-check/pick-list?${params}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      });

      const responseData: ApiResponse = await response.json();
      if (responseData.bins) {
        setRowData(
          sortBy(
            responseData.bins.map((bin) => {
              const orderBags = sortBy(responseData?.orderBags?.filter((orderBag) => orderBag.binId === bin.id), "sequence");
              return {
                order: responseData.data.find((order) => order.id === bin.orderId) || null,
                bin,
                orderBags,
                orderBagsLabel: orderBags
                  .map((orderBag) => orderBag.sequence)
                  .sort()
                  .join(", "),
                key: `${bin.order?.friendlyId}-${orderBags.map((curr) => curr.sequence).join("-")}`, // sortable key
              };
            }),
            "key"
          )
        );
      } else {
        setRowData(null);
      }
    } catch (err) {
      console.log(err);
      appLog((err as Error).message, true, "error", err as Error);
    }
  };

  useEffect(() => {
    fetchApiData();
    return clearScannedData;
  }, [clearScannedData]);

  return (
    <FullLayout header={<HeaderNav />}>
      {selectedCard && <Scan data={selectedCard} onClose={() => setSelectedCard(null)} />}
      <List data={rowData || []} onSelect={setSelectedCard} />
    </FullLayout>
  );
};

export default PickList;
